import { render, staticRenderFns } from "./MM.vue?vue&type=template&id=4b854c66&"
import script from "./MM.vue?vue&type=script&lang=js&"
export * from "./MM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports